/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {MenuComponent} from '../../../../../../../_metronic/assets/ts/components'
import {ID, KTSVG, QUERIES} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../../../../../../_metronic/common/table/core/ListViewProvider'
import {useQueryResponse} from '../../../../../../../_metronic/common/table/core/QueryResponseProvider'
import {useAuth} from '../../../../../auth'
import {deleteStockCategory} from '../../core/_requests'

type Props = {
  id: ID
}

const StockCategoryActionsCell: FC<Props> = ({id}) => {
  const {setItemIdForUpdate} = useListView()
  const {query} = useQueryResponse()
  const queryClient = useQueryClient()
  const {currentUser} = useAuth()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const deleteItem = useMutation(() => deleteStockCategory(currentUser, id), {
    onSuccess: () => {
      queryClient.invalidateQueries([`${QUERIES.STOCK_CATEGORIES_LIST}-${query}`])
    },
  })

  return (
    <>
      <a href='#' className='btn btn-light btn-active-light-primary btn-sm' data-kt-menu-trigger='click' data-kt-menu-placement='bottom-end'>
        Actions
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a>
      <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4' data-kt-menu='true'>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={() => setItemIdForUpdate(id)}>
            Edit
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={async () => await deleteItem.mutateAsync()}>
            Delete
          </a>
        </div>
      </div>
    </>
  )
}

export {StockCategoryActionsCell}
